import { useEffect } from 'react';
import { registerApplications } from '../single-spa-config';

/**
 * Custom hook to register single-spa applications when import map is ready.
 * This prevents race conditions where single-spa tries to import modules before the import map is available.
 */
export const useImportMapReady = (): void => {
  useEffect(() => {
    // Check if import map is already loaded
    if (document.querySelector('script[type="importmap"]')) {
      registerApplications();
      return;
    }

    const cleanup = () => {
      document.removeEventListener('importmapready', startRegistration);
    };

    const startRegistration = () => {
      cleanup();
      registerApplications();
    };

    document.addEventListener('importmapready', startRegistration);

    return () => {
      cleanup();
    };
  }, []);
};
